import { render, staticRenderFns } from "./SystemRole.vue?vue&type=template&id=581d8047&scoped=true"
import script from "./SystemRole.vue?vue&type=script&lang=js"
export * from "./SystemRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581d8047",
  null
  
)

export default component.exports